import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { environment } from 'src/environments/environment';
import { ObrasProjeto } from '../../models/obras-projeto.model';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { ObrasProjetoService } from '../../services/obras-projeto.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';
import { HistoryService } from '../../services/history.service';

@Component({
  selector: 'app-detalhe-entrega-projeto-obras-list',
  templateUrl: './detalhe-entrega-projeto-obras-list.component.html',
  styleUrls: ['./detalhe-entrega-projeto-obras-list.component.scss']
})
export class DetalheEntregaProjetoObrasListComponent extends BaseListComponent<ObrasProjeto> implements OnInit, OnDestroy {

  idProjeto: number;
  infoProjeto: ProjetoCadastro;
  @Input() idEntrega: number;
  canCreatWork: boolean;
  obrasList: ObrasProjeto[];

  constructor(
    private myService: ObrasProjetoService,
    public activatedRoute: ActivatedRoute,
    private pesquisaGeralService: PesquisaGeralService,
    private historyService: HistoryService,
    private router: Router,
  ) {
    super();
  }

  ngOnInit() {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;

      this.iniList();
    });
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  iniList() {
    this.addSub(
      this.myService.getObrasList(this.idEntrega).subscribe((res) => {
        this.obrasList = res['obras'];
        this.canCreatWork = res['canCreatWork'];
        this.loaded();
      })
    );
  }
}
